import React, { useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useMutation } from "@apollo/client";
import { POST_STRIPE_INTENT, POST_STRIPE_CONFIRM_INTENT } from "../../../graphql/queries";

const CheckoutForm = props => {
  const { t, submitTitle, name, email, onSubmit, document } = props;
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const createOptions = () => {
    return {
      style: {
        base: {
          fontSize: "16px",
          color: "black",
          fontFamily: "inherit",
          letterSpacing: "0.025em",
          "::placeholder": {
            color: "white"
          }
        },
        invalid: {
          color: "cg-red"
        }
      }
    };
  };

  const [createIntent] = useMutation(POST_STRIPE_INTENT);
  const [confirmIntent] = useMutation(POST_STRIPE_CONFIRM_INTENT);

  const handleSubmit = async e => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: "card",
        billing_details: { name, email },
        card: elements.getElement(CardElement)
      });
      if (paymentMethod) {
        const {
          data: { stripeCreateIntent: intentData }
        } = await createIntent({
          variables: { paymentMethodId: paymentMethod.id, documentId: document.id }
        });
        const { results: intentResults, intent } = intentData;
        if (intentResults.requires_action) {
          const { error: errorAction, paymentIntent } = await stripe.handleCardAction(
            intentResults.payment_intent_client_secret
          );
          if (errorAction) throw new Error(errorAction.message);
          const { data: confirmedIntentData } = await confirmIntent({ variables: { documentId: document.id, intentId: paymentIntent.id } });
          await onSubmit({ intentId: confirmedIntentData.stripeConfirmIntent.intent.id, type: "stripe" });
        } else await onSubmit({ intentId: intent.id, type: "stripe" });
      } else throw new Error(error.message || error);
      setIsSubmitting(false);
    } catch (e) {
      setError(e.toString());
      setIsSubmitting(false);
      setError(e.toString());
    }
  };

  const handleChange = ({ error }) => {
    if (error) setError(error.message);
    else setError("");
    setIsSubmitting(false);
  };

  return (
    <div className="stripeForm">
      <form onSubmit={handleSubmit}>
        <label>
          {t("enterYourCardDetails")}:
          <CardElement onChange={handleChange} {...createOptions()} />
        </label>
        <div className="error" role="alert">
          {error ? <p>{error}</p> : null}
        </div>
        <button disabled={!stripe || isSubmitting} type="submit">
          {isSubmitting ? "Please wait while submitting..." : submitTitle}
        </button>
      </form>
    </div>
  );
};

export function BancontactForm ({ t, submitTitle, checkout, currentUri }) {
  const [error, setError] = useState("");
  const stripe = useStripe();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [createIntent] = useMutation(POST_STRIPE_INTENT);

  // Bancontact
  const handleBancontactSubmit = async e => {
    e.preventDefault();
    const name = e.target.name.value;
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const { data } = await createIntent({ variables: { documentId: checkout.id, provider: "bancontact" } });
      await stripe.confirmBancontactPayment(data.stripeCreateIntent.intent.client_secret, {
        payment_method: { billing_details: { name } },
        return_url: currentUri.path("/checkout/payment/confirm/bancontact").toString()
      });
    } catch (e) {
      console.log(e);
      setError(e.toString());
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form id="bancontactForm" onSubmit={handleBancontactSubmit}>
      <input name="name" placeholder={t("enterYourName")} type="text" autoComplete="off" required />
      <div className="error" role="alert">
        {error ? <p>{error}</p> : null}
      </div>
      <button disabled={!stripe || isSubmitting} type="submit">
        {isSubmitting ? "Please wait while submitting..." : t("payWithBancontact")}
      </button>
    </form>
  );
}

export default CheckoutForm;
